const Template=`<div>
<left-menu :modems="modems"></left-menu>
<notifications></notifications>
</div>`
export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page5_notifications/template.js